module.exports = __webpack_public_path__ + "js/2.77a08402.worker.js"